import { render, staticRenderFns } from "./DiagnosticoSocioambientalParaguai.vue?vue&type=template&id=6c5d03f8&lang=pug"
import script from "./DiagnosticoSocioambientalParaguai.vue?vue&type=script&lang=js"
export * from "./DiagnosticoSocioambientalParaguai.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticoSocioambientalParaguai.vue?vue&type=style&index=0&id=6c5d03f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports